import { Components } from "@thisgorilla/primate-ds";
import { useEffect, useMemo, useState } from "react";
import { useTheme } from "styled-components";

import WavesurferPlayer from "@wavesurfer/react";
import { formatTime } from "../../../utils";
import { FlexRowCenter } from "../Styles";
import AudioBarProps from "./AudioBar";
import { Container, TimerContainer } from "./style";
import RegionsPlugin from "wavesurfer.js/dist/plugins/regions";

let timer: NodeJS.Timeout | null;

const Footer = ({
  wavesurfer,
  setWavesurfer,
  isPlaying,
  setIsPlaying,
  url,
  // setIsModalShareOpen,
  isViewOnly,
}: AudioBarProps.Footer) => {
  const { typography, Color } = useTheme();
  const [currentTime, setCurrentTime] = useState(0);
  const [regions, setRegions] = useState<RegionsPlugin | null>(null);
  const totalDuration = Number((wavesurfer?.getDuration() ?? 0).toFixed());

  const plugins = useMemo(() => {
    const regionsPlugin = RegionsPlugin.create();
    setRegions(regionsPlugin);
    return isViewOnly ? [] : [regionsPlugin];
  }, [isViewOnly]);

  useEffect(() => {
    if (isPlaying) {
      setCurrentTime(Number(wavesurfer?.getCurrentTime().toFixed() ?? 0));
      timer = setInterval(() => {
        setCurrentTime(Number(wavesurfer?.getCurrentTime().toFixed() ?? 0));
      }, 500);
    } else {
      if (timer) {
        clearInterval(timer);
      }
    }
    return () => {
      if (timer) {
        clearInterval(timer);
      }
    };
  }, [isPlaying, wavesurfer]);

  return (
    <FlexRowCenter $gapInPx={8}>
      <TimerContainer>
        <Components.Text
          style={{ tokenStyle: typography.Body.S }}
          text={formatTime(currentTime) + " / " + formatTime(totalDuration)}
          color={"#F3F5F6"}
          lineHeight="line-height-50"
          renderInSingleLine
        />
      </TimerContainer>
      <Container>
        <WavesurferPlayer
          height={40}
          waveColor="white"
          progressColor={Color.icon.brand.default.value}
          barGap={2}
          barHeight={2}
          barWidth={4}
          barAlign="bottom"
          barRadius={4}
          url={url}
          plugins={plugins}
          onReady={(ws) => {
            setWavesurfer(ws);
            if (regions) {
              // regions.enableDragSelection({});
            }
          }}
          onPlay={() => setIsPlaying(true)}
          onPause={() => setIsPlaying(false)}
          onTimeupdate={(ws) => {
            setCurrentTime(Number(ws.getCurrentTime().toFixed() ?? 0));
          }}
        />
      </Container>
      {/* <div>
        <Components.IconButton
          kind="Secondary"
          iconType={"Share"}
          disabled={false}
          size="Medium"
          onClick={() => {
            if (isViewOnly) return;
            setIsModalShareOpen(true);
          }}
          IconButtonColor={"#F3F5F6"}
        />
      </div> */}
    </FlexRowCenter>
  );
};

export default Footer;
